import React, { useEffect, useRef, useState } from 'react';
import Button from '../../components/base/Button';

export default function Home() {
  // ----- References & State (plain JS – no TS generics) -----
  const canvasRef = useRef(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('idle'); // 'idle' | 'success' | 'error'
  const [selectedProject, setSelectedProject] = useState(null);
  const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);

  // ----- Static data (unchanged) -----
  const projects = [
    {
      title: 'Website für Kleinunternehmen #1',
      desc: 'Responsive Website-Erstellung für lokales Heizung und Sanitär Kleinunternehmen mit modernem Design',
      image:
        'https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/59d8af71dbcb55beffac9e829f5ef360.png',
      status: 'Fast fertig',
      progress: 90,
      fullDescription:
        'Dieses Projekt umfasst die komplette Entwicklung einer modernen, responsiven Website für Meister Grabow, ein lokales Heizung- und Sanitärunternehmen. Die Website wurde mit React und Tailwind CSS entwickelt und bietet eine benutzerfreundliche Navigation, detaillierte Servicebeschreibungen und ein integriertes Kontaktformular.',
      features: [
        'Vollständig responsive Design für alle Geräte',
        'SEO-optimierte Struktur für bessere Suchmaschinenplatzierung',
        'Integriertes Kontaktformular mit E-Mail-Benachrichtigungen',
        'Moderne Bildergalerie für abgeschlossene Projekte',
        'Schnelle Ladezeiten durch optimierte Performance',
        'Barrierefreie Gestaltung nach WCAG-Standards',
      ],
      technologies: ['React', 'Tailwind CSS', 'JavaScript', 'HTML5', 'CSS3'],
      timeline: '6 Wochen Entwicklungszeit',
      client: 'Meister Grabow',
    },
    {
      title: 'Website für Kleinunternehmen #2',
      desc: 'Allround Haus- und Sanierungswebsite für Jo Allrounder Service mit umfassendem Serviceangebot',
      image:
        'https://public.readdy.ai/ai/img_res/a44e43ec4931212cd093fd77c2c1ce14.jpg',
      status: 'In Bearbeitung',
      progress: 50,
      fullDescription:
        'Umfassende Website-Entwicklung für Jo Allrounder Service, ein vielseitiges Haus- und Sanierungsunternehmen. Die Website präsentiert das breite Servicespektrum von Renovierungen über Reparaturen bis hin zu kompletten Hausmodernisierungen mit einer benutzerfreundlichen Galerie und Kontaktmöglichkeiten.',
      features: [
        'Übersichtliche Darstellung aller Dienstleistungen',
        'Interaktive Projektgalerie mit Vorher-Nachher-Bildern',
        'Kostenvoranschlag-Anfrage-System',
        'Responsive Design für alle Endgeräte',
        'SEO-optimiert für lokale Suchanfragen',
        'Integriertes Kontaktformular und Terminbuchung',
      ],
      technologies: ['React', 'Tailwind CSS', 'JavaScript', 'HTML5', 'CSS3'],
      timeline: '8 Wochen geplant',
      client: 'Jo Allrounder Service',
    },
    {
      title: 'TikTok-Kanal Aufbau',
      desc: 'Mein eigener TikTok-Kanal über Parfüm-Reviews und Duft-Erklärungen',
      image:
        'https://readdy.ai/api/search-image?query=TikTok%20content%20creation%20for%20perfume%20reviews%2C%20smartphone%20filming%20perfume%20bottles%2C%20fragrance%20education%20content%2C%20modern%20social%20media%20setup%20with%20perfume%20collection%2C%20creative%20perfume%20presentation%20for%20social%20media%2C%20influencer%20workspace%20with%20luxury%20fragrances&width=400&height=300&seq=project-realistic-3&orientation=landscape',
      status: 'Laufend',
      progress: 75,
      fullDescription:
        'Mein persönlicher TikTok-Kanal, auf dem ich verschiedene Parfüms näher erkläre und veranschauliche. Durch kreative Videos bringe ich meinen Followern die Welt der Düfte näher - von Nischendüften bis hin zu bekannten Designer-Parfüms. Der Kanal kombiniert Bildung mit Unterhaltung und hilft Menschen dabei, den perfekten Duft für sich zu finden.',
      features: [
        'Detaillierte Parfüm-Reviews und Duftbeschreibungen',
        'Vergleiche zwischen verschiedenen Duftkategorien',
        'Tipps zur richtigen Anwendung von Parfüms',
        'Vorstellung von Nischen- und Designer-Düften',
        'Interaktive Q&A-Sessions mit der Community',
        'Saisonale Duftempfehlungen und Trends',
      ],
      technologies: [
        'TikTok Creator Tools',
        'Adobe Premiere Pro',
        'Canva',
        'Analytics Tools',
      ],
      timeline: 'Laufendes Projekt seit 3 Monaten',
      client: 'Eigener Kanal',
    },
    {
      title: 'Dokumentarfilm Gruppenprojekt',
      desc: 'Geschichtsdokumentarfilm - Gewinner Geschichtswettbewerb Sachsen-Anhalt',
      image:
        'https://readdy.ai/api/search-image?query=Documentary%20film%20production%20setup%20with%20professional%20camera%20equipment%2C%20historical%20research%20materials%2C%20award%20certificate%2C%20film%20editing%20workspace%2C%20historical%20documents%20and%20photographs%2C%20professional%20filming%20environment%2C%20creative%20documentary%20production%20scene&width=400&height=300&seq=project-realistic-4&orientation=landscape',
      status: 'Abgeschlossen',
      progress: 100,
      fullDescription:
        'Preisgekrönter Dokumentarfilm über die lokale Geschichte Wernigerodes während der DDR-Zeit. Das Projekt gewann den ersten Platz beim Geschichtswettbewerb des Bundespräsidenten in Sachsen-Anhalt.',
      features: [
        'Umfangreiche historische Recherche in Archiven',
        'Interviews mit 15 Zeitzeugen',
        'Professionelle Filmproduktion mit 4K-Qualität',
        '45-minütige Dokumentation mit Untertiteln',
        'Auszeichnung beim Landeswettbewerb',
        'Verfügbar auf YouTube für die Öffentlichkeit',
      ],
      technologies: [
        'Adobe Premiere Pro',
        'After Effects',
        'Audacity',
        'Professionelle Kameraausrüstung',
      ],
      timeline: '8 Monate Produktionszeit',
      client: 'Schulprojekt - Landschulheim Grovesmühle',
      videoUrl: 'https://www.youtube.com/watch?v=hs28A2wgMoA&t=1s',
    },
    {
      title: 'Personal Branding',
      desc: 'Aufbau meiner eigenen Online-Präsenz und Portfolio',
      image:
        'https://readdy.ai/api/search-image?query=Personal%20branding%20workspace%20with%20laptop%20showing%20portfolio%20website%2C%20business%20cards%2C%20logo%20designs%2C%20brand%20color%20palette%2C%20creative%20design%20materials%20&width=400&height=300&seq=project-realistic-5&orientation=landscape',
      status: 'Laufend',
      progress: 60,
      fullDescription:
        'Strategischer Aufbau meiner persönlichen Marke als Marketing-Student und angehender Webdesigner. Das Projekt umfasst die Entwicklung einer einheitlichen visuellen Identität und den Aufbau einer starken Online-Präsenz.',
      features: [
        'Entwicklung einer einheitlichen visuellen Identität',
        'Professionelle Portfolio-Website',
        'Social Media Strategie für LinkedIn und Instagram',
        'Networking-Materialien und Visitenkarten',
        'Content-Plan für regelmäßige Beiträge',
        'SEO-Optimierung für bessere Auffindbarkeit',
      ],
      technologies: ['React', 'Tailwind CSS', 'Adobe Creative Suite', 'Figma'],
      timeline: 'Laufendes Projekt',
      client: 'Eigenprojekt',
    },
  ];

  // ----- Modal handling -----
  const openProjectModal = (project) => {
    setSelectedProject(project);
    setIsProjectModalOpen(true);
    // Prevent background scrolling
    document.body.style.overflow = 'hidden';
  };

  const closeProjectModal = () => {
    setIsProjectModalOpen(false);
    setSelectedProject(null);
    // Restore background scrolling
    document.body.style.overflow = 'unset';
  };

  // ----- Form handling (plain JS) -----
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSend = new URLSearchParams();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('subject', formData.subject);
      formDataToSend.append('message', formData.message);

      const response = await fetch(
        'https://readdy.ai/api/form/d3hpsfmdn2fs4irjn510',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formDataToSend,
        }
      );

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        console.error(
          'Form submission failed:',
          response.status,
          response.statusText
        );
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  // ----- Scrolling helper -----
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  // ----- Canvas animation (unchanged logic) -----
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Set canvas size & handle resize
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // ----- Thread animation setup -----
    const lines = [];

    for (let i = 0; i < 40; i++) {
      lines.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        angle: Math.random() * Math.PI * 2,
        length: Math.random() * 150 + 30,
        speed: Math.random() * 0.015 + 0.005,
        opacity: Math.random() * 0.2 + 0.05,
      });
    }

    let mouseX = 0;
    let mouseY = 0;
    let isMouseMoving = false;
    let animationFrameId;

    const handleMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      isMouseMoving = true;
      setTimeout(() => {
        isMouseMoving = false;
      }, 100);
    };

    canvas.addEventListener('mousemove', handleMouseMove);

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      lines.forEach((line) => {
        line.angle += line.speed;

        if (isMouseMoving) {
          const dx = mouseX - line.x;
          const dy = mouseY - line.y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < 120) {
            const force = (120 - distance) / 120;
            line.angle += force * 0.08;
            line.opacity = Math.min(0.6, line.opacity + force * 0.2);
          }
        }

        const startX = line.x;
        const startY = line.y;
        const endX = startX + Math.cos(line.angle) * line.length;
        const endY = startY + Math.sin(line.angle) * line.length;

        const gradient = ctx.createLinearGradient(startX, startY, endX, endY);
        gradient.addColorStop(0, `rgba(199, 161, 122, ${line.opacity})`);
        gradient.addColorStop(
          0.5,
          `rgba(212, 184, 150, ${line.opacity * 0.8})`
        );
        gradient.addColorStop(
          1,
          `rgba(232, 213, 196, ${line.opacity * 0.6})`
        );

        ctx.strokeStyle = gradient;
        ctx.lineWidth = 1.5;
        ctx.lineCap = 'round';

        ctx.beginPath();
        ctx.moveTo(startX, startY);
        ctx.lineTo(endX, endY);
        ctx.stroke();

        if (!isMouseMoving && line.opacity > 0.05) {
          line.opacity *= 0.995;
        }

        // Wrap around screen
        if (line.x < -line.length) line.x = canvas.width + line.length;
        if (line.x > canvas.width + line.length) line.x = -line.length;
        if (line.y < -line.length) line.y = canvas.height + line.length;
        if (line.y > canvas.height + line.length) line.y = -line.length;
      });

      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    // Cleanup
    return () => {
      window.removeEventListener('resize', resizeCanvas);
      canvas.removeEventListener('mousemove', handleMouseMove);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  // Add Schema.org JSON-LD
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Person",
      "name": "Dion Bamme",
      "jobTitle": "Marketing Management Student",
      "description": "18-jähriger Marketing Management Student aus Wernigerode mit Leidenschaft für kreative Kampagnen und innovative digitale Lösungen",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com",
      "image": "https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/82caf8bfc0c2ebad31fa3967515772f6.png",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Wernigerode",
        "addressCountry": "DE"
      },
      "alumniOf": {
        "@type": "EducationalOrganization",
        "name": "Hochschule Harz",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Wernigerode",
          "addressCountry": "DE"
        }
      },
      "knowsAbout": [
        "Marketing Management",
        "Social Media Marketing",
        "Webdesign",
        "Content Creation",
        "Digital Marketing"
      ],
      "sameAs": [
        "https://www.linkedin.com/in/dion-bamme",
        "https://www.instagram.com/dion.bamme",
        "https://github.com/dionbamme"
      ]
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  // ----- Render -----
  return (
    <div className="min-h-screen bg-lumaz-cream text-gray-900 relative overflow-hidden">
      {/* Threads Background Canvas */}
      <canvas
        ref={canvasRef}
        className="fixed inset-0 w-full h-full z-0"
        style={{
          background:
            'linear-gradient(135deg, #faf9f7 0%, #f5f3f0 50%, #f0ede8 100%)',
        }}
      />

      {/* Animated Background Elements */}
      <div className="fixed inset-0 z-0 overflow-hidden">
        {/* Floating Geometric Shapes */}
        <div className="absolute top-20 left-10 w-32 h-32 bg-gradient-to-r from-lumaz-secondary/20 to-lumaz-primary/20 rounded-full animate-float-slow"></div>
        <div className="absolute top-40 right-20 w-24 h-24 bg-gradient-to-r from-lumaz-light/30 to-lumaz-secondary/30 rounded-lg rotate-45 animate-float-reverse"></div>
        <div className="absolute bottom-32 left-20 w-20 h-20 bg-gradient-to-r from-lumaz-primary/25 to-lumaz-light/25 rounded-full animate-pulse-slow"></div>
        <div className="absolute bottom-20 right-32 w-28 h-28 bg-gradient-to-r from-lumaz-secondary/15 to-lumaz-primary/15 rounded-lg animate-spin-slow"></div>
        
        {/* Animated Lines */}
        <div className="absolute top-1/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-lumaz-secondary/30 to-transparent animate-slide-x"></div>
        <div className="absolute top-3/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-lumaz-primary/30 to-transparent animate-slide-x-reverse"></div>
        
        {/* Particle Effect */}
        <div className="absolute inset-0">
          {[...Array(15)].map((_, i) => (
            <div
              key={i}
              className="absolute w-2 h-2 bg-lumaz-secondary/40 rounded-full animate-float-particle"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${3 + Math.random() * 4}s`
              }}
            ></div>
          ))}
        </div>
      </div>

      {/* Content Overlay */}
      <div className="relative z-10">
        {/* Hero Section */}
        <section
          id="home"
          className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8"
        >
          <div className="max-w-7xl mx-auto text-center">
            <div>
              {/* Name with Enhanced Animation */}
              <div className="mb-8">
                <h1 className="text-6xl md:text-8xl font-black mb-4 relative">
                  <span className="lumaz-text-gradient animate-text-glow inline-block animate-slide-down">
                    Dion
                  </span>
                  <br />
                  <span className="text-lumaz-primary relative animate-text-wave inline-block animate-slide-up-delayed">
                    Bamme
                  </span>
                  {/* Animated Underline */}
                  <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-lumaz-secondary to-lumaz-primary rounded-full animate-expand-width"></div>
                </h1>
              </div>

              {/* Subtitle with Typewriter Effect */}
              <div className="relative mb-8">
                <p className="text-2xl md:text-3xl font-bold text-lumaz-primary mb-2 animate-typewriter">
                  Marketing Management Student
                </p>
                <p className="text-lg md:text-xl text-lumaz-secondary mb-4 animate-fade-in-up">
                  🎨 Kreativ • 📊 Analytisch • 🚀 Innovativ
                </p>
                <div className="flex justify-center items-center space-x-4 text-sm text-lumaz-secondary">
                  <span className="px-3 py-1 bg-lumaz-light/20 text-lumaz-primary rounded-full font-medium border border-lumaz-light/30 animate-bounce-in" style={{animationDelay: '0.2s'}}>
                    18 Jahre
                  </span>
                  <span className="px-3 py-1 bg-lumaz-light/20 text-lumaz-primary rounded-full font-medium border border-lumaz-light/30 animate-bounce-in" style={{animationDelay: '0.4s'}}>
                    1. Semester
                  </span>
                  <span className="px-3 py-1 bg-lumaz-light/20 text-lumaz-primary rounded-full font-medium border border-lumaz-light/30 animate-bounce-in" style={{animationDelay: '0.6s'}}>
                    Wernigerode
                  </span>
                </div>
              </div>

              {/* CTA Buttons with Enhanced Animation */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
                <button onClick={() => scrollToSection('portfolio')} className="animate-scale-in" style={{animationDelay: '0.8s'}}>
                  <Button
                    variant="primary"
                    size="lg"
                    className="group relative overflow-hidden lumaz-button border-0 text-white hover:scale-105 transition-all duration-500"
                  >
                    <span className="relative z-10">
                      Meine Projekte entdecken
                    </span>
                    <div className="absolute inset-0 bg-gradient-to-r from-lumaz-primary to-lumaz-secondary opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  </Button>
                </button>
                <button onClick={() => scrollToSection('contact')} className="animate-scale-in" style={{animationDelay: '1s'}}>
                  <Button
                    variant="outline"
                    size="lg"
                    className="group border-2 border-lumaz-secondary hover:border-lumaz-primary text-lumaz-secondary hover:text-white transition-all duration-500 bg-transparent hover:bg-gradient-to-r hover:from-lumaz-secondary hover:to-lumaz-primary"
                  >
                    <span>Kontakt aufnehmen</span>
                  </Button>
                </button>
              </div>

              {/* Stats with Staggered Animation */}
              <div className="grid grid-cols-3 gap-8 max-w-md mx-auto">
                <div className="text-center animate-count-up" style={{animationDelay: '1.2s'}}>
                  <div className="text-3xl font-bold text-lumaz-primary mb-1 animate-number-roll">5+</div>
                  <div className="text-sm text-lumaz-secondary">Projekte</div>
                </div>
                <div className="text-center animate-count-up" style={{animationDelay: '1.4s'}}>
                  <div className="text-3xl font-bold text-lumaz-primary mb-1 animate-number-roll">100%</div>
                  <div className="text-sm text-lumaz-secondary">Motivation</div>
                </div>
                <div className="text-center animate-count-up" style={{animationDelay: '1.6s'}}>
                  <div className="text-3xl font-bold text-lumaz-primary mb-1 animate-number-roll">∞</div>
                  <div className="text-sm text-lumaz-secondary">Ideen</div>
                </div>
              </div>
            </div>
          </div>

          {/* Enhanced Scroll Indicator */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce-gentle">
            <div className="w-8 h-12 border-2 border-lumaz-secondary rounded-full flex justify-center relative overflow-hidden">
              <div className="w-1 h-3 bg-lumaz-secondary rounded-full mt-2 animate-scroll-dot"></div>
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-lumaz-secondary/20 to-transparent animate-pulse"></div>
            </div>
            <p className="text-xs text-lumaz-secondary mt-2 animate-fade-in-out">Scroll</p>
          </div>
        </section>

        {/* About Section */}
        <section id="about" className="py-20 lumaz-section relative">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-5xl font-black mb-4 text-lumaz-primary">
                Über <span className="lumaz-text-gradient">mich</span>
              </h2>
              <p className="text-xl text-lumaz-secondary">Wer ich bin und was mich antreibt</p>
            </div>

            <div className="grid lg:grid-cols-2 gap-12 items-center">
              {/* Text Content */}
              <div className="space-y-6 animate-slide-in-left">
                <div className="lumaz-card rounded-3xl p-8">
                  <h3 className="text-2xl font-bold text-lumaz-primary mb-4">Meine Geschichte</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Als 18-jähriger Marketing Management Student an der Hochschule Harz in Wernigerode 
                    bringe ich frische Perspektiven und innovative Ideen in die Welt des digitalen Marketings. 
                    Meine Leidenschaft liegt in der Verbindung von Kreativität und Analytik.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Durch verschiedene Projekte - von Webentwicklung über Social Media bis hin zu 
                    Dokumentarfilmen - habe ich gelernt, komplexe Herausforderungen mit kreativen 
                    Lösungen anzugehen.
                  </p>
                </div>

                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-lumaz-light/20 backdrop-blur-sm rounded-2xl p-6 border border-lumaz-light/30 hover-lift">
                    <div className="w-12 h-12 bg-lumaz-secondary rounded-full flex items-center justify-center mb-4">
                      <i className="ri-lightbulb-line text-white text-xl"></i>
                    </div>
                    <h4 className="text-lg font-semibold text-lumaz-primary mb-2">Kreativität</h4>
                    <p className="text-lumaz-secondary text-sm">Innovative Lösungen für komplexe Probleme</p>
                  </div>
                  <div className="bg-lumaz-primary/20 backdrop-blur-sm rounded-2xl p-6 border border-lumaz-primary/30 hover-lift">
                    <div className="w-12 h-12 bg-lumaz-primary rounded-full flex items-center justify-center mb-4">
                      <i className="ri-bar-chart-line text-white text-xl"></i>
                    </div>
                    <h4 className="text-lg font-semibold text-lumaz-primary mb-2">Analytik</h4>
                    <p className="text-lumaz-secondary text-sm">Datengetriebene Entscheidungen treffen</p>
                  </div>
                </div>
              </div>

              {/* Image */}
              <div className="relative animate-slide-in-right">
                <div className="relative rounded-3xl overflow-hidden border border-lumaz-light/30 hover-lift">
                  <img
                    src="https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/82caf8bfc0c2ebad31fa3967515772f6.png"
                    alt="Dion Bamme - Marketing Student"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-lumaz-primary/30 to-transparent"></div>
                </div>
                
                {/* Floating Stats */}
                <div className="absolute -bottom-6 -left-6 glass-effect rounded-2xl p-6 border border-lumaz-light/20">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-lumaz-primary mb-1">1.</div>
                    <div className="text-sm text-lumaz-secondary">Semester</div>
                  </div>
                </div>
                
                <div className="absolute -top-6 -right-6 glass-effect rounded-2xl p-6 border border-lumaz-light/20">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-lumaz-secondary mb-1">5+</div>
                    <div className="text-sm text-lumaz-secondary">Projekte</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Skills */}
            <div className="mt-16">
              <h3 className="text-3xl font-bold text-lumaz-primary text-center mb-12">Meine Fähigkeiten</h3>
              <div className="grid md:grid-cols-3 gap-8">
                {[
                  {
                    category: 'Marketing',
                    skills: ['Social Media Marketing', 'Content Creation', 'Brand Strategy', 'Analytics'],
                    icon: 'ri-megaphone-line',
                    color: 'lumaz-secondary'
                  },
                  {
                    category: 'Webentwicklung',
                    skills: ['React', 'HTML/CSS', 'JavaScript', 'Responsive Design'],
                    icon: 'ri-code-line',
                    color: 'lumaz-primary'
                  },
                  {
                    category: 'Kreativ',
                    skills: ['Video Editing', 'Graphic Design', 'Photography', 'Storytelling'],
                    icon: 'ri-palette-line',
                    color: 'lumaz-light'
                  }
                ].map((skillGroup, index) => (
                  <div key={index} className="lumaz-card rounded-3xl p-8 hover-lift">
                    <div className={`w-16 h-16 bg-${skillGroup.color} rounded-full flex items-center justify-center mb-6`}>
                      <i className={`${skillGroup.icon} text-white text-2xl`}></i>
                    </div>
                    <h4 className="text-xl font-bold text-lumaz-primary mb-4">{skillGroup.category}</h4>
                    <ul className="space-y-2">
                      {skillGroup.skills.map((skill, skillIndex) => (
                        <li key={skillIndex} className="flex items-center text-gray-700">
                          <div className={`w-2 h-2 bg-${skillGroup.color} rounded-full mr-3`}></div>
                          {skill}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>

            {/* Education & Career */}
            <div className="mt-16 grid lg:grid-cols-2 gap-12">
              {/* Education */}
              <div className="lumaz-card rounded-3xl p-8 hover-lift">
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-lumaz-secondary rounded-full flex items-center justify-center mr-4">
                    <i className="ri-graduation-cap-line text-white text-xl"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-lumaz-primary">Bildungsweg</h3>
                </div>
                
                <div className="space-y-6">
                  <div className="relative pl-6 border-l-2 border-lumaz-primary/30">
                    <div className="absolute -left-2 top-0 w-4 h-4 bg-lumaz-primary rounded-full"></div>
                    <div className="text-sm text-lumaz-secondary font-medium">Sep 2025 - heute</div>
                    <h4 className="text-lg font-semibold text-lumaz-primary mt-1">Marketing Management (B.A.)</h4>
                    <p className="text-gray-700">1. Semester • Hochschule Harz, Wernigerode</p>
                    <p className="text-lumaz-secondary text-sm mt-2">Schwerpunkte: Digitales Marketing, Marktforschung, Konsumentenverhalten</p>
                  </div>

                  <div className="relative pl-6 border-l-2 border-lumaz-secondary/30">
                    <div className="absolute -left-2 top-0 w-4 h-4 bg-lumaz-light rounded-full"></div>
                    <div className="text-sm text-lumaz-secondary font-medium">2024</div>
                    <h4 className="text-lg font-semibold text-lumaz-primary mt-1">Abitur</h4>
                    <p className="text-gray-700">Landschulheim Grovesmühle, Veckenstedt</p>
                    <p className="text-lumaz-secondary text-sm mt-2">Abiturnote: 2,0</p>
                  </div>

                  <div className="relative pl-6 border-l-2 border-lumaz-secondary/30">
                    <div className="absolute -left-2 top-0 w-4 h-4 bg-lumaz-light rounded-full"></div>
                    <div className="text-sm text-lumaz-secondary font-medium">2021-2024</div>
                    <h4 className="text-lg font-semibold text-lumaz-primary mt-1">Landschulheim Grovesmühle</h4>
                    <p className="text-gray-700">Veckenstedt</p>
                    <p className="text-lumaz-secondary text-sm mt-2">Klasse 10-12 • Abitur mit Note 2,0</p>
                  </div>

                  <div className="relative pl-6">
                    <div className="absolute -left-2 top-0 w-4 h-4 bg-lumaz-light/60 rounded-full"></div>
                    <div className="text-sm text-lumaz-secondary font-medium">2018-2021</div>
                    <h4 className="text-lg font-semibold text-lumaz-primary mt-1">Landesgymnasium für Musik</h4>
                    <p className="text-gray-700">Wernigerode</p>
                    <p className="text-lumaz-secondary text-sm mt-2">Klasse 5-10 • Musikalische Ausbildung</p>
                  </div>
                </div>
              </div>

              {/* Career */}
              <div className="lumaz-card rounded-3xl p-8 hover-lift">
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-lumaz-primary rounded-full flex items-center justify-center mr-4">
                    <i className="ri-briefcase-line text-white text-xl"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-lumaz-primary">Beruflicher Werdegang</h3>
                </div>
                
                <div className="space-y-6">
                  <div className="relative pl-6 border-l-2 border-lumaz-primary/30">
                    <div className="absolute -left-2 top-0 w-4 h-4 bg-lumaz-primary rounded-full"></div>
                    <div className="text-sm text-lumaz-secondary font-medium">2025 - heute</div>
                    <h4 className="text-lg font-semibold text-lumaz-primary mt-1">Freelance Webdesigner</h4>
                    <p className="text-gray-700">Selbstständig</p>
                    <p className="text-lumaz-secondary text-sm mt-2">Entwicklung von Websites für Kleinunternehmen und Startups</p>
                  </div>
                  
                  <div className="relative pl-6 border-l-2 border-lumaz-primary/30">
                    <div className="absolute -left-2 top-0 w-4 h-4 bg-lumaz-light rounded-full"></div>
                    <div className="text-sm text-lumaz-secondary font-medium">2023</div>
                    <h4 className="text-lg font-semibold text-lumaz-primary mt-1">Minijob Gastronomie</h4>
                    <p className="text-gray-700">Restaurant XO & Café Nachtigall, Wernigerode</p>
                    <p className="text-lumaz-secondary text-sm mt-2">4 Monate • Service und Kundenbetreuung</p>
                  </div>
                  
                  <div className="relative pl-6 border-l-2 border-lumaz-primary/30">
                    <div className="absolute -left-2 top-0 w-4 h-4 bg-lumaz-light rounded-full"></div>
                    <div className="text-sm text-lumaz-secondary font-medium">2023</div>
                    <h4 className="text-lg font-semibold text-lumaz-primary mt-1">Praktikum Chocotech GmbH</h4>
                    <p className="text-gray-700">Wernigerode</p>
                    <p className="text-lumaz-secondary text-sm mt-2">1 Woche • Einblick in Produktionsprozesse und Unternehmensabläufe</p>
                  </div>
                  
                  <div className="relative pl-6">
                    <div className="absolute -left-2 top-0 w-4 h-4 bg-lumaz-light/60 rounded-full"></div>
                    <div className="text-sm text-lumaz-secondary font-medium">2023</div>
                    <h4 className="text-lg font-semibold text-lumaz-primary mt-1">Praktikum Polizei Wernigerode</h4>
                    <p className="text-gray-700">Wernigerode</p>
                    <p className="text-lumaz-secondary text-sm mt-2">1 Woche • Einblick in Polizeiarbeit und öffentliche Sicherheit</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* Portfolio Section */}
        <section
          id="portfolio"
          className="py-20 bg-white/50 backdrop-blur-sm relative"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-5xl font-black mb-4 text-lumaz-primary">
                Meine <span className="lumaz-text-gradient">Projekte</span>
              </h2>
              <p className="text-xl text-lumaz-secondary">Woran ich gerade arbeite</p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {projects.map((project, index) => (
                <div
                  key={index}
                  className="group lumaz-card rounded-3xl overflow-hidden hover-lift"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-lumaz-primary/60 to-transparent"></div>
                    <div className="absolute top-4 right-4">
                      <span className="px-3 py-1 rounded-full text-xs font-bold bg-lumaz-light/20 text-lumaz-primary border border-lumaz-light/30 backdrop-blur-sm">
                        {project.status}
                      </span>
                    </div>
                  </div>

                  <div className="p-6">
                    <h3 className="text-xl font-bold mb-3 text-lumaz-primary group-hover:text-lumaz-secondary transition-colors duration-300">
                      {project.title}
                    </h3>
                    <p className="text-gray-600 mb-4 leading-relaxed">
                      {project.desc}
                    </p>

                    {/* Progress Bar */}
                    <div className="mb-4">
                      <div className="flex justify-between text-sm text-lumaz-secondary mb-1">
                        <span>Fortschritt</span>
                        <span>{project.progress}%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div
                          className="bg-lumaz-secondary h-2 rounded-full transition-all duration-1000"
                          style={{ width: `${project.progress}%` }}
                        ></div>
                      </div>
                    </div>

                    <Button
                      variant="outline"
                      size="sm"
                      className="group-hover:bg-lumaz-light/20 group-hover:border-lumaz-secondary group-hover:text-lumaz-secondary transition-all duration-300 border-lumaz-light text-lumaz-secondary"
                      onClick={() => openProjectModal(project)}
                    >
                      Details ansehen
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="py-20 lumaz-section relative">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-5xl font-black mb-4 text-lumaz-primary">
                Lass uns <span className="lumaz-text-gradient">sprechen</span>
              </h2>
              <p className="text-xl text-lumaz-secondary">Bereit für dein nächstes Projekt?</p>
            </div>

            <div className="grid lg:grid-cols-2 gap-12">
              {/* Contact Info */}
              <div className="space-y-8">
                <div className="lumaz-card rounded-3xl p-8 hover-lift">
                  <h3 className="text-2xl font-bold text-lumaz-primary mb-6">Kontaktiere mich</h3>
                  
                  <div className="space-y-6">
                    {[
                      {
                        icon: 'ri-mail-line',
                        label: 'E-Mail',
                        value: 'dion.bamme@gmail.com',
                        color: 'lumaz-secondary'
                      },
                      {
                        icon: 'ri-phone-line',
                        label: 'Telefon',
                        value: '+49 176 45725863',
                        color: 'lumaz-primary'
                      },
                      {
                        icon: 'ri-map-pin-line',
                        label: 'Standort',
                        value: 'Wernigerode, Deutschland',
                        color: 'lumaz-light'
                      },
                      {
                        icon: 'ri-graduation-cap-line',
                        label: 'Studium',
                        value: 'Marketing Management, Hochschule Harz',
                        color: 'lumaz-secondary'
                      }
                    ].map((contact, index) => (
                      <div key={index} className="flex items-center space-x-4">
                        <div className={`w-12 h-12 bg-${contact.color} rounded-full flex items-center justify-center`}>
                          <i className={`${contact.icon} text-white text-lg`}></i>
                        </div>
                        <div>
                          <div className="text-sm text-lumaz-secondary">{contact.label}</div>
                          <div className="text-lumaz-primary font-medium">{contact.value}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Social Links */}
                <div className="lumaz-card rounded-3xl p-8 hover-lift">
                  <h4 className="text-lg font-semibold text-lumaz-primary mb-4">Folge mir</h4>
                  <div className="flex space-x-4">
                    {[
                      { icon: 'ri-linkedin-fill', url: '#', color: 'lumaz-secondary' },
                      { icon: 'ri-instagram-line', url: 'https://www.instagram.com/dionsaurier/', color: 'lumaz-primary' },
                      { icon: 'ri-twitter-fill', url: '#', color: 'lumaz-light' },
                      { icon: 'ri-github-fill', url: '#', color: 'lumaz-secondary' }
                    ].map((social, index) => (
                      <a
                        key={index}
                        href={social.url}
                        className={`w-12 h-12 bg-${social.color} hover:bg-lumaz-primary rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer hover:scale-110`}
                      >
                        <i className={`${social.icon} text-white text-lg`}></i>
                      </a>
                    ))}
                  </div>
                </div>
              </div>

              {/* Contact Form */}
              <div className="lumaz-card rounded-3xl p-8 hover-lift">
                <h3 className="text-2xl font-bold text-lumaz-primary mb-6">Schreib mir eine Nachricht</h3>
                
                <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form id="contact-form">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-lumaz-secondary mb-2">
                        Name *
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 bg-white/50 border border-lumaz-light rounded-xl text-lumaz-primary placeholder-lumaz-secondary/60 focus:outline-none focus:border-lumaz-secondary focus:ring-1 focus:ring-lumaz-secondary transition-all duration-300"
                        placeholder="Dein Name"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-lumaz-secondary mb-2">
                        E-Mail *
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 bg-white/50 border border-lumaz-light rounded-xl text-lumaz-primary placeholder-lumaz-secondary/60 focus:outline-none focus:border-lumaz-secondary focus:ring-1 focus:ring-lumaz-secondary transition-all duration-300"
                        placeholder="deine@email.com"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-lumaz-secondary mb-2">
                      Betreff *
                    </label>
                    <input
                      type="text"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 bg-white/50 border border-lumaz-light rounded-xl text-lumaz-primary placeholder-lumaz-secondary/60 focus:outline-none focus:border-lumaz-secondary focus:ring-1 focus:ring-lumaz-secondary transition-all duration-300"
                      placeholder="Worum geht es?"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-lumaz-secondary mb-2">
                      Nachricht *
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      maxLength={500}
                      rows={5}
                      className="w-full px-4 py-3 bg-white/50 border border-lumaz-light rounded-xl text-lumaz-primary placeholder-lumaz-secondary/60 focus:outline-none focus:border-lumaz-secondary focus:ring-1 focus:ring-lumaz-secondary transition-all duration-300 resize-none"
                      placeholder="Erzähl mir von deinem Projekt..."
                    ></textarea>
                    <div className="text-right text-xs text-lumaz-secondary mt-1">
                      {formData.message.length}/500 Zeichen
                    </div>
                  </div>

                  {/* Submit Status */}
                  {submitStatus === 'success' && (
                    <div className="bg-green-500/20 border border-green-500/30 rounded-xl p-4">
                      <div className="flex items-center">
                        <i className="ri-check-circle-line text-green-600 text-xl mr-3"></i>
                        <span className="text-green-700">Nachricht erfolgreich gesendet!</span>
                      </div>
                    </div>
                  )}
                  
                  {submitStatus === 'error' && (
                    <div className="bg-red-500/20 border border-red-500/30 rounded-xl p-4">
                      <div className="flex items-center">
                        <i className="ri-error-warning-line text-red-600 text-xl mr-3"></i>
                        <span className="text-red-700">Fehler beim Senden. Bitte versuche es erneut.</span>
                      </div>
                    </div>
                  )}

                  <Button
                    type="submit"
                    variant="primary"
                    size="lg"
                    disabled={isSubmitting}
                    className="w-full lumaz-button text-white"
                  >
                    {isSubmitting ? (
                      <span className="flex items-center justify-center">
                        <i className="ri-loader-4-line animate-spin mr-2"></i>
                        Wird gesendet...
                      </span>
                    ) : (
                      'Nachricht senden'
                    )}
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* Footer Section */}
        <footer className="bg-gray-800 text-white py-12 border-t border-gray-700">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-4 gap-8">
              {/* Logo & Description */}
              <div className="md:col-span-2">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-20 h-20 bg-gradient-to-r from-lumaz-primary to-lumaz-secondary rounded-full flex items-center justify-center text-white font-bold text-2xl hover:scale-110 transition-transform duration-300 cursor-pointer shadow-lg">
                    DB
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white" style={{ fontFamily: '"Pacifico", serif' }}>
                      Dion Bamme
                    </h3>
                    <p className="text-gray-300">Marketing Management Student</p>
                  </div>
                </div>
                <p className="text-gray-300 leading-relaxed max-w-md">
                  Leidenschaftlicher Marketing Student mit dem Fokus auf kreative Kampagnen 
                  und innovative digitale Lösungen für moderne Unternehmen.
                </p>
              </div>

              {/* Quick Links */}
              <div>
                <h4 className="text-lg font-semibold mb-4 text-white">Navigation</h4>
                <ul className="space-y-2">
                  <li>
                    <button onClick={() => scrollToSection('home')} className="text-gray-300 hover:text-lumaz-secondary transition-colors duration-300 cursor-pointer">
                      Home
                    </button>
                  </li>
                  <li>
                    <button onClick={() => scrollToSection('about')} className="text-gray-300 hover:text-lumaz-secondary transition-colors duration-300 cursor-pointer">
                      Über mich
                    </button>
                  </li>
                  <li>
                    <button onClick={() => scrollToSection('portfolio')} className="text-gray-300 hover:text-lumaz-secondary transition-colors duration-300 cursor-pointer">
                      Portfolio
                    </button>
                  </li>
                  <li>
                    <button onClick={() => scrollToSection('contact')} className="text-gray-300 hover:text-lumaz-secondary transition-colors duration-300 cursor-pointer">
                      Kontakt
                    </button>
                  </li>
                </ul>
              </div>

              {/* Contact Info */}
              <div>
                <h4 className="text-lg font-semibold mb-4 text-white">Kontakt</h4>
                <div className="space-y-2">
                  <p className="text-gray-300 flex items-center">
                    <i className="ri-mail-line mr-2 text-lumaz-secondary"></i>
                    dion.bamme@gmail.com
                  </p>
                  <p className="text-gray-300 flex items-center">
                    <i className="ri-phone-line mr-2 text-lumaz-secondary"></i>
                    +49 176 45725863
                  </p>
                  <p className="text-gray-300 flex items-center">
                    <i className="ri-map-pin-line mr-2 text-lumaz-secondary"></i>
                    Wernigerode, Deutschland
                  </p>
                </div>
              </div>
            </div>

            {/* Social Links */}
            <div className="mt-8 pt-8 border-t border-gray-700">
              <div className="flex flex-col md:flex-row justify-between items-center">
                <div className="flex space-x-4 mb-4 md:mb-0">
                  {[
                    { icon: 'ri-linkedin-fill', url: '#', label: 'LinkedIn' },
                    { icon: 'ri-instagram-line', url: 'https://www.instagram.com/dionsaurier/', label: 'Instagram' },
                    { icon: 'ri-twitter-fill', url: '#', label: 'Twitter' },
                    { icon: 'ri-github-fill', url: '#', label: 'GitHub' }
                  ].map((social, index) => (
                    <a
                      key={index}
                      href={social.url}
                      target={social.url.startsWith('http') ? '_blank' : '_self'}
                      rel={social.url.startsWith('http') ? 'noopener noreferrer' : undefined}
                      className="w-10 h-10 bg-gray-700 hover:bg-lumaz-secondary rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer hover:scale-110"
                      aria-label={social.label}
                    >
                      <i className={`${social.icon} text-gray-300 hover:text-white text-lg`}></i>
                    </a>
                  ))}
                </div>

                {/* Copyright & Legal Links */}
                <div className="text-center md:text-right">
                  <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 text-sm mb-3">
                    <Link 
                      to="/legal" 
                      className="text-gray-300 hover:text-lumaz-secondary transition-colors duration-300 cursor-pointer font-medium px-3 py-1 rounded hover:bg-gray-700"
                    >
                      Impressum
                    </Link>
                    <Link 
                      to="/privacy" 
                      className="text-gray-300 hover:text-lumaz-secondary transition-colors duration-300 cursor-pointer font-medium px-3 py-1 rounded hover:bg-gray-700"
                    >
                      Datenschutz
                    </Link>
                  </div>
                  <p className="text-gray-400 text-sm">© 2024 Dion Bamme. Alle Rechte vorbehalten.</p>
                </div>
              </div>
            </div>
          </div>
        </footer>

        {/* Project Details Modal */}
        {isProjectModalOpen && selectedProject && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div
              className="absolute inset-0 bg-black/60 backdrop-blur-sm"
              onClick={closeProjectModal}
            ></div>

            <div className="relative bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-hidden border border-lumaz-light/30 shadow-2xl">
              {/* Header */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={selectedProject.image}
                  alt={selectedProject.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-lumaz-primary via-lumaz-primary/50 to-transparent"></div>

                {/* Close */}
                <button
                  onClick={closeProjectModal}
                  className="absolute top-4 right-4 w-10 h-10 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/20 transition-colors duration-300 border border-white/20"
                >
                  <i className="ri-close-line text-white text-xl"></i>
                </button>

                {/* Status */}
                <div className="absolute top-4 left-4">
                  <span className="px-4 py-2 rounded-full text-sm font-bold bg-lumaz-light/20 text-white border border-white/30 backdrop-blur-sm">
                    {selectedProject.status}
                  </span>
                </div>

                {/* Title/Desc */}
                <div className="absolute bottom-6 left-6 right-6">
                  <h2 className="text-3xl font-bold text-white mb-2">
                    {selectedProject.title}
                  </h2>
                  <p className="text-white/90 text-lg">{selectedProject.desc}</p>
                </div>
              </div>

              {/* Content */}
              <div className="p-8 max-h-[calc(90vh-16rem)] overflow-y-auto">
                {/* Progress */}
                <div className="mb-8">
                  <div className="flex justify-between items-center mb-3">
                    <h3 className="text-xl font-semibold text-lumaz-primary">
                      Projektfortschritt
                    </h3>
                    <span className="text-2xl font-bold text-lumaz-secondary">
                      {selectedProject.progress}%
                    </span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-3">
                    <div
                      className="bg-gradient-to-r from-lumaz-secondary to-lumaz-primary h-3 rounded-full transition-all duration-1000"
                      style={{ width: `${selectedProject.progress}%` }}
                    ></div>
                  </div>
                </div>

                {/* Description */}
                <div className="mb-8">
                  <h3 className="text-xl font-semibold text-lumaz-primary mb-4">
                    Projektbeschreibung
                  </h3>
                  <p className="text-gray-700 leading-relaxed text-lg">
                    {selectedProject.fullDescription}
                  </p>
                </div>

                {/* Features */}
                <div className="mb-8">
                  <h3 className="text-xl font-semibold text-lumaz-primary mb-4">
                    Hauptfeatures
                  </h3>
                  <div className="grid md:grid-cols-2 gap-3">
                    {selectedProject.features.map((feature, index) => (
                      <div key={index} className="flex items-start">
                        <div className="w-6 h-6 bg-lumaz-secondary rounded-full flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                          <i className="ri-check-line text-white text-sm"></i>
                        </div>
                        <span className="text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Technologies */}
                <div className="mb-8">
                  <h3 className="text-xl font-semibold text-lumaz-primary mb-4">
                    Verwendete Technologien
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {selectedProject.technologies.map((tech, index) => (
                      <span
                        key={index}
                        className="px-3 py-1 bg-lumaz-light/20 text-lumaz-primary rounded-full text-sm font-medium border border-lumaz-light/30"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Details */}
                <div className="grid md:grid-cols-2 gap-8">
                  <div>
                    <h4 className="text-lg font-semibold text-lumaz-primary mb-2">
                      Kunde
                    </h4>
                    <p className="text-gray-700">{selectedProject.client}</p>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-lumaz-primary mb-2">
                      Zeitrahmen
                    </h4>
                    <p className="text-gray-700">{selectedProject.timeline}</p>
                  </div>
                </div>

                {/* TikTok Statistics - Only show for TikTok project */}
                {selectedProject.title === 'TikTok-Kanal Aufbau' && (
                  <div className="mt-8 mb-8">
                    <h3 className="text-xl font-semibold text-lumaz-primary mb-6">
                      Kanal-Statistiken (365 Tage)
                    </h3>
                    <div className="grid md:grid-cols-2 gap-6 mb-8">
                      <div className="bg-gradient-to-br from-pink-500/20 to-purple-500/20 p-6 rounded-2xl border border-pink-500/30">
                        <div className="flex items-center justify-between mb-4">
                          <div className="w-12 h-12 bg-pink-600 rounded-full flex items-center justify-center">
                            <i className="ri-eye-line text-white text-xl"></i>
                          </div>
                          <div className="text-right">
                            <div className="text-3xl font-bold text-pink-600">182K</div>
                            <div className="text-sm text-pink-500">Aufrufe</div>
                          </div>
                        </div>
                        <div className="text-sm text-gray-700 font-medium">Video-Aufrufe</div>
                        <div className="text-xs text-gray-500 mt-1">Parfüm-Content Performance</div>
                      </div>

                      <div className="bg-gradient-to-br from-red-500/20 to-pink-500/20 p-6 rounded-2xl border border-red-500/30">
                        <div className="flex items-center justify-between mb-4">
                          <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                            <i className="ri-heart-line text-white text-xl"></i>
                          </div>
                          <div className="text-right">
                            <div className="text-3xl font-bold text-red-600">8.5K</div>
                            <div className="text-sm text-red-500">Likes</div>
                          </div>
                        </div>
                        <div className="text-sm text-gray-700 font-medium">Gesamte Likes</div>
                        <div className="text-xs text-gray-500 mt-1">Engagement Rate: 4.7%</div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Documentary Video Player - Only show for Documentary project */}
                {selectedProject.title === 'Dokumentarfilm Gruppenprojekt' && selectedProject.videoUrl && (
                  <div className="mt-8 mb-8">
                    <h3 className="text-xl font-semibold text-lumaz-primary mb-6">
                      Dokumentarfilm ansehen
                    </h3>
                    <div className="bg-gray-100 rounded-2xl p-6 border border-lumaz-light/30">
                      <div className="aspect-video rounded-xl overflow-hidden bg-black">
                        <iframe
                          src="https://www.youtube.com/embed/hs28A2wgMoA?start=1"
                          title="Dokumentarfilm - Geschichtswettbewerb Sachsen-Anhalt"
                          className="w-full h-full"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                        ></iframe>
                      </div>
                      <div className="mt-4 flex items-center justify-between">
                        <div>
                          <h4 className="text-lg font-semibold text-lumaz-primary">
                            Wernigerode in der DDR-Zeit
                          </h4>
                          <p className="text-gray-600 text-sm">
                            45-minütige Dokumentation über die lokale Geschichte
                          </p>
                        </div>
                        <a
                          href={selectedProject.videoUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-300 flex items-center space-x-2"
                        >
                          <i className="ri-youtube-fill text-lg"></i>
                          <span>Auf YouTube</span>
                        </a>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
